import $ from "jquery";
import "slick-carousel";

const reviewSlider = () => {
  const target = ".review-slider-wrapper";
  const $target = $(target);

  const init = () => {
    $(document).ready(function () {
      if ($target.length) {
        exec();
      }
    });
  };

  const exec = () => {
    $target.slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      infinite: true,
      arrows: true,
      dots: false,
      adaptiveHeight: true,
      nextArrow: ".review-slider-btn__next",
      prevArrow: ".review-slider-btn__prev",
      responsive: [
        {
          breakpoint: 1025,
          settings: {
            dots: true,
          },
        },
      ],
    });
  };

  init();
};

try {
  reviewSlider();
} catch (error) {
  throw Error(error);
}
